import { Component, OnInit } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

import {
    Category, Lessee, Income
} from './../../../../../_models';

import { IncomeFormComponent } from '../income-form/income-form.component';

@Component({
    selector: 'app-income-new',
    templateUrl: '../../common/form/form-new.component.html',
    styleUrls: ['../../common/form/form-new.component.scss']
})
export class IncomeNewComponent extends IncomeFormComponent implements OnInit {
    formHeader = {
        icon: 'fa fa-money',
        text: 'REGISTRAR INGRESO'
    };
    curr = this.options['lessee'];
    constructor(private _fbNew: FormBuilder,
        private _locationNew: Location,
        private income: Income,
        private router: Router,
        private _lesseeModel: Lessee,
        private _categoryIncomeNewModel: Category
    ) {
        super(_fbNew,
            _locationNew, router, _lesseeModel, _categoryIncomeNewModel);
        this.form.controls.type.setValue('lessee');
        this.form.valueChanges.subscribe(formValue => {
            this.requests$ = this.income.post(this.body);
        });
    }
    ngOnInit() {
        this.router.events.subscribe((route) => {
            if (route instanceof NavigationEnd) {
                this.selectTypeData.clear();
                this.selectCategory.clear();
                this.dobPicker.clear();
                this.dataFetched = true;
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/incomes/income-new/income-new.component.ts